export default {
  title: 'My orders',
  subtitle: 'Track delivery, reveal keys, and download invoices.',
  filter: {
    ariaLabel: 'Filter orders',
    all: 'All',
    active: 'Active',
    completed: 'Completed',
    failed: 'Failed',
  },
  noMatch: 'No orders match this filter.',
  empty: {
    heading: 'No orders yet.',
    body: 'Once you check out, your purchases will show up here with delivery status and key reveal.',
    cta: 'Browse catalog',
  },
  row: {
    qty: 'qty {qty}',
    orderRef: 'Order #{ref}',
    viewOrder: 'View order',
    downloadInvoice: 'Download invoice',
    wallet: 'Wallet',
    topupName: 'Wallet funds top-up',
    ref: 'Ref #{ref}',
  },
  detail: {
    backToOrders: 'Back to orders',
    notFound: 'Order not found',
    totalPaid: 'Total paid',
    qty: 'qty {qty}',
    step: {
      paid: 'Paid',
      processing: 'Processing',
      delivered: 'Delivered',
      refunded: 'Refunded',
      failed: 'Failed',
    },
    inFlight: 'Keys typically deliver within a few minutes — this page refreshes automatically.',
    keys: {
      heading: 'Your keys',
      count: 'no keys | one key | {count} keys',
      encryptedNotice: 'Keys are encrypted at rest. Click reveal to view — your access is logged.',
      revealButton: 'Reveal keys',
      activationKey: 'Activation key',
      copy: 'Copy',
      copied: 'Copied',
    },
    activityLog: 'Activity log',
  },
  status: {
    CREATED: 'Created',
    PAID: 'Paid',
    PROCESSING: 'Processing',
    DELIVERED: 'Delivered',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    REFUNDED: 'Refunded',
    PENDING: 'Pending',
  },
  topup: {
    missingRef: 'Missing payment reference',
    backToBilling: 'Back to billing',
    tryAgain: 'Try again',
    stillPending: 'Still pending',
    stillPendingBody: "The provider hasn't confirmed yet. You won't be charged twice — refresh this page later or open your wallet to see the credit when it lands.",
    waitingSec: 'Waiting {sec}s · updates automatically',
    redirecting: 'Redirecting to wallet…',
    failureReason: 'Reason: {reason}',
    PENDING: {
      title: 'Waiting for confirmation…',
      sub: 'Your payment provider will confirm the payment in a moment. This page updates automatically.',
    },
    COMPLETED: {
      title: 'Top-up successful',
      sub: 'Your wallet has been credited.',
    },
    FAILED: {
      title: 'Top-up failed',
      sub: 'The payment was not completed. Your wallet was not charged.',
    },
    REFUNDED: {
      title: 'Top-up refunded',
      sub: 'The payment was reversed by the provider.',
    },
  },
};
